"use strict";

import jQuery from 'jquery';

/**
 * @classdesc
 * Container-Modul für eine Zusammenfassung von mehreren Modulen in der Sidebar.
 *
 * @class
 * @extends gc.gis.module.GCAbstractModule
 * @memberof gc.gis.module
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 *
 * @param {Object} options Optionen
 * @param {string} [options.label=null] Bezeichnung
 * @param {string} [options.alias=undefined] Eindeutiger Alias für {@link gc.gis.GCApplication#modules|Modulregistry}
 * @param {string} [options.target] HTML-ID des Kontainerelements
 * @param {string} [options.icon] Icon für den Launcher
 */
gc.gis.module.GCAbstractContainerModule = function (options)
{
    gc.gis.module.GCAbstractModule.call(this, options);

    this.icon = options.icon;
    this._modules = {};

    this._launcher_index = -1;
};
gc.gis.module.GCAbstractContainerModule.prototype = Object.create(gc.gis.module.GCAbstractModule.prototype);


/**
 * Prüft, ob das übergebene Modul bereits im Container existiert.
 *
 * @param module
 * @return {boolean}
 * @public
 */
gc.gis.module.GCAbstractContainerModule.prototype.containsModule = function (module)
{
    return this._modules[module.getAlias()] !== undefined;
};

/**
 * Fügt ein Modul der Liste hinzu und liefert die Referenz auf das korrespondierende SidbarContent-Element zurück.
 *
 * @param {gc.gis.module.GCAbstractModule} module
 * @param {jQuery} element
 * @param {string} opt_icon
 * @return {gc.gis.ui.GCSidebarContent}
 * @public
 */
gc.gis.module.GCAbstractContainerModule.prototype.addModule = function (module, element, opt_icon)
{
    var self = this;
    var _sidebar_content = this._modules[module.getAlias()];

    if (!_sidebar_content)
    {
        _sidebar_content = new gc.gis.ui.GCSidebarContent({
            label: module.getLabel(),
            'parent': this.launcher.content,
            launcher: this.launcher.element,
            element: element
        });

        this._launcher_menu.append(jQuery('<li>', {
            html: gc.gis.iface.ui.sidebar.createSubmenuItem({
                label: module.getLabel(),
                icon: opt_icon,
                click: function (evt) {
                    evt.preventDefault();
                    try {
                        gc.gis.iface.ui.sidebar.setContent(_sidebar_content);
                    }
                    catch (err) {
                        gc.gis.iface.log.error(self, err);
                    }
                    jQuery(this).blur();
                }
            })
        }));

        this._modules[module.getAlias()] = _sidebar_content;

        this._updateVisibility();
    }

    return _sidebar_content;
};

/**
 * Erzeugt den Inhalt des Moduls.
 *
 * @return {JQuery|*}
 * @private
 */
gc.gis.module.GCAbstractContainerModule.prototype._render = function()
{
    if (!this._element)
    {
        this._element = jQuery('<div>', {
            'class': 'gc-sidebar-launcher-panel'
        });
        this._launcher_menu = jQuery('<ul>');
        this._element.html(this._launcher_menu);

        // Launcher
        this.launcher = {
            label: this.label,
            icon: this.icon,
            content: new gc.gis.ui.GCSidebarContent({
                label: this.label,
                'parent': null,
                element: this._element
            })
        };
        this._launcher_index = gc.gis.iface.ui.sidebar.addLauncher(this.launcher);
        this._updateVisibility();
    }

    return this._element;
};

/**
 * Aktualisiert die Sichtbarkeit des Moduls in der Launcher-Liste.
 *
 * @private
 */
gc.gis.module.GCAbstractContainerModule.prototype._updateVisibility = function()
{
    if (this._launcher_index > -1)
    {
        gc.gis.iface.ui.sidebar.setLauncherVisibility(this._launcher_index, Object.keys(this._modules).length > 0);
    }
};